import { render, staticRenderFns } from "./ViolationHistory.vue?vue&type=template&id=26151897&scoped=true"
import script from "./ViolationHistory.vue?vue&type=script&lang=js"
export * from "./ViolationHistory.vue?vue&type=script&lang=js"
import style0 from "./ViolationHistory.vue?vue&type=style&index=0&id=26151897&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26151897",
  null
  
)

export default component.exports